import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import Loading from "../../Loading/Loading";
import Snackbar from "../../../Snackbar";
import { getCoursesByAppToken } from "../../../store/actions/CreateApp/getCoursesByAppToken";
import CardCourse from "../../UI/CardCourse";
import CardCourseMinimized from "../../UI/CardCourseMinimized";
import CardCourseMinimizedBlank from "../../UI/CardCourseMinimizedBlank";
  
// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const SelectCourseInReduxPopUp= ({selectCoursePopUp})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:true});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
    const userdata = useSelector((state)=>state?.user?.user);
   useEffect(()=>{

    setLoader({status:true});
    const user = dispatch(getCoursesByAppToken(
        {userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",AppToken:AppToken}));
    /* get response as Promise   */
    user.then(response => {
    // console.log(response)
      if(response){
        if(response?.logout){

         dispatch({type:"LOGOUT"});
       }
        if(response?.Courses){  setCourses(response?.Courses);
            setCoursesBlank([])
        setResponseMessage("Courses Loaded Successfully");
          
        setSnackbarColor("rgba(144, 202, 249,1)");
       
    setLoader({status:false});
   
    // setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },1000)
       }else{


        
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
         
    setLoader({status:false});
   
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
       
        }else{


        
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
             
        setLoader({status:false});
       
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
     
  /* resetting Login input Fields */
  
  
  
  // history.push('/dashboard/profile');
  
}
    ).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
     setLoader({status:false});
      // console.error(error);
      
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
    });

   },[])
   
   
       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
<div className=" " style={{padding:"15px"}}>
<div className="  "> 

    <div className="AppCardsOuter">
     <div className="selectThumbImgOuterAll"  style={{zIndex:99999}}>
   
  
   <div  className="selectThumbImgOuter" style={{zIndex:999999,padding:"20px",background:"#f1f1f1"}}>
    
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"15px",top:"10px",margin:"10px",
      background:"#958FDA",zIndex:999999,position:"absolute",}} onClick={()=>selectCoursePopUp(false)}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div>
        <div  className="AppTitleInCourses" >#App : {App?.appName} </div>
        <div  className="AppTitleInCourses" >Select A Course And Add Contents </div>
 
<div style={{overflowY:"auto",height:"80%"} }>
<div  className="gridForSelectCoursePopupInner" >
    {Courses?.map((app, index) => (
    //  console.log(app)   
     <CardCourseMinimized selectCoursePopUp={(state)=>selectCoursePopUp(state)}  key={index} number={index+1} course={app?.course} icon="" arrow="" alt="" title={app?.course?.CourseName} details="" AppToken={app?.course?.AppToken}   />
     
    
    ))
       
       }
       {CoursesBlank?.map((app, index) => (
    // console.log(app?.course?.CourseName)   
     <CardCourseMinimizedBlank   key={index}   />
       ))  }
</div></div>
</div>

</div></div>
     </div>
     <div></div>
     </div>
     </>


}
export default SelectCourseInReduxPopUp;